module.exports = __webpack_public_path__ + "static/media/logout.169c4bb4.svg";